import { createFileRoute } from '@tanstack/react-router';

import { AvisGoogle } from '@/features/reglages/avis-panel';

export const Route = createFileRoute('/_app/settings/reviews')({
  component: AvisGoogle,
});
